// extracted by mini-css-extract-plugin
module.exports = {"info-container":"InfoText_info-container__rd1AG","info-text":"InfoText_info-text__YXeMi"};